<div class="report-dialog-container">
  <!-- Header cố định -->
  <div class="dialog-header">
    <h2 class="dialog-title">{{ '::Report:Title' | abpLocalization }}</h2>
    <button type="button" class="btn-close" (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <!-- Content có thể cuộn -->
  <div class="dialog-content">
    <form [formGroup]="reportForm" (ngSubmit)="submitReport()">
      <div class="report-options">
        <div *ngFor="let reason of reportReasons; let i = index" class="report-option">
          <div class="option-header">
            <p-radioButton 
              [inputId]="'reason_' + i" 
              [value]="reason.value" 
              formControlName="reasonCode">
            </p-radioButton>
            <label [for]="'reason_' + i" class="option-label f-s-16">{{ reason.label }}</label>
          </div>
          <div class="option-description f-s-14">
            <p>{{ reason.description | abpLocalization }}</p>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer cố định -->
  <div class="dialog-footer">
    <div class="footer-buttons">
      <button type="button" class="btn-cancel" (click)="close()">
        {{ '::Common:CancelButton' | abpLocalization }}
      </button>
      <button 
        type="button"
        class="btn-report" 
        [disabled]="reportForm.invalid || isSubmitting"
        (click)="submitReport()">
        {{ '::Report:Btn:Confirm' | abpLocalization }}
      </button>
    </div>
  </div>
</div>
